<template>
  <v-container class="grey lighten-5">
    <v-row class="justify-start">
      <div class="accordeon-container">
        <div class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3">
          <div class="d-flex align-center">
            <div
              style="cursor: pointer"
              @click="isVisibilt = !isVisibilt"
              class="d-flex align-center px-2 py-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="13.351"
                viewBox="0 0 22 13.351"
              >
                <path
                  id="Icon_awesome-chevron-down"
                  data-name="Icon awesome-chevron-down"
                  d="M10.543,21.68.752,11.889a1.209,1.209,0,0,1,0-1.71L1.894,9.037a1.209,1.209,0,0,1,1.708,0l7.8,7.759,7.8-7.759a1.209,1.209,0,0,1,1.708,0l1.142,1.142a1.209,1.209,0,0,1,0,1.71L12.253,21.68A1.209,1.209,0,0,1,10.543,21.68Z"
                  transform="translate(-0.398 -8.683)"
                  fill="#6f6f6f"
                />
              </svg>
            </div>
            <h3 class="color-darkGray">{{ cardType }}</h3>
          </div>
        </div>
        <WarningDialog
          ref="warningDialog"
          @ok="dialogOK"
          text="O pagamento precisa de estar aprovado até 2 horas antes da consulta ser realizada, ou esta
          será automaticamente cancelada. Poderá acompanhar o estado do seu pagamento através dos
          detalhes da consulta agendada. O pagamento é analisado automaticamente, e por isso só
          necessita de acompanhar o processo nos detalhes da consulta."
        />
        <template v-if="itens.length === 0 & paymentMethodType != 'sepa_account'">
          <div class="d-flex flex-row align-center px-5 py-2 mt-3" id="noCard">
            <p class="ma-2 f-990 color-darkGray">
              Você não tem nenhum cartão de crédito cadastrado, cadastre um agora.
            </p>
            <v-btn
              large
              color="secondary"
              style="align-self: center"
              :loading="loader"
              @click="addCard"
            >
              Adicionar Cartão
            </v-btn>
          </div>
        </template>

        
        <template v-if="itens.length === 0 & paymentMethodType === 'sepa_account'">
          <div class="d-flex flex-row align-center px-5 py-2 mt-3" id="noCard">
            <p class="ma-2 f-990 color-darkGray">
              Você não tem nenhum débito direto cadastrado, cadastre um agora.
            </p>
            <v-btn
              large
              color="secondary"
              style="align-self: center"
              :loading="loader"
              @click="addSepa"
            >
              Adicionar SEPA
            </v-btn>
          </div>
        </template>


        
        <v-dialog
          v-model="modalFormCard"
          transition="dialog-top-transition"
          @click:outside="close"
          class="login-dialog"
          max-width="500px"
        >
            <FormCard :saveCardMethod="saveCardMethod" :showForm="true" ref="newFormCard"/>
        </v-dialog>
        
        
        <v-dialog
          v-model="modalFormSepa"
          transition="dialog-top-transition"
          @click:outside="close"
          class="login-dialog"
          max-width="500px"
        >
            <FormSepa :saveSepadMethod="saveSepadMethod" :showForm="true"  ref="newFormSepa" />
        </v-dialog>
        
        <div v-if="isVisibilt">
          <template v-if="!modelValue">
            <div
              class="d-flex flex-row align-center justify-space-between px-5 py-2 mt-3"
              v-for="(item, index) in getCards"
              :key="index + '_card'"
            >
              <div class="d-flex flex-column align-start justify-center">
                <p class="ma-0 f-990 color-darkGray">
                  {{ paymentMethodType === 'sepa_account' ? 'Nome' : 'Número' }}
                </p>
                <div class="d-flex flex-row align-center justify-center">
                  <p
                    v-if="paymentMethodType === 'sepa_account'"
                    class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
                  >
                    {{ maskName(item.account_name) }}
                  </p>
                  <p v-else class="ma-0 f-12 primary--text font-weight-medium valor-cartao">
                    {{ `**** ${item.number.substring(20, 14)}` }}
                  </p>
                </div>
              </div>
              <div class="d-flex flex-column align-start justify-center">
                <p class="ma-0 f-990 color-darkGray">
                  {{ paymentMethodType === 'sepa_account' ? 'IBAN' : 'Validade' }}
                </p>
                <p
                  v-if="paymentMethodType === 'sepa_account'"
                  class="ma-0 f-12 primary--text font-weight-medium valor-cartao"
                >
                  **** {{ item.iban_code.substring(item.iban_code.length - 4) }}
                </p>
                <p v-else class="ma-0 f-12 primary--text font-weight-medium valor-cartao">
                  {{ item.due_date }}
                </p>
              </div>
              <div>
                <v-btn
                  @click="onSelectChoice(item)"
                  class="br-8"
                  height="40"
                  color="secondary"
                  small
                >
                  Selecionar
                </v-btn>
              </div>
            </div>
          </template>
        </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
import WarningDialog from './WarningDialog.vue';
import FormCard from './FormCard.vue';
import FormSepa from './FormSepa.vue';

import { creatMethodSepa, getMethodSepa } from '../../services/paymentMethodSepa';

import { createCreditCard, getCreditCards } from '../../services/patients';
export default {
  components: {
    WarningDialog,
    FormCard,
    FormSepa
  },
  props: {
    value: {
      type: [Number, String, Object],
      default: () => null,
    },
    cardType: { type: String },
    itens: { type: Array },
    paymentMethodType: { type: String },
  },
  data() {
    return {
      isVisibilt: false,
      modelValue: null,
      itemEvent: {},
      modalFormCard: false,
      addNewCard: false,
      modalFormSepa: false,
      addNewSepa: false
    };
  },
  mounted() {
    this.modelValue = this.value;
  },
  computed: {
    getCards() {
      return this.itens.map((v) => ({
        payment_method_type: this.paymentMethodType,
        ...v,
      }));
    },
    cartaoAtual() {
      const row = this.getCards.find((v) =>
        v.id === !this.modelValue ? null : this.modelValue.id,
      );
      if (!row) {
        return '';
      }
      return row;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, OldValue) {
        if (newValue !== this.modelValue) {
          this.modelValue = newValue;
        }
      },
    },
    async addNewCard() {
      this.itens = await getCreditCards()
      return this.itens.map((v) => ({
        payment_method_type: this.paymentMethodType,
        ...v,
      }));
    },
    async addNewSepa() {
      const res = await getMethodSepa();
      this.itens = res.data;
    }
  },
  methods: {
    onSelectChoice(value) {
      this.itemEvent = {};
      if (this.paymentMethodType !== 'sepa_account') {
        this.$emit('input', value);
        return;
      }
      this.itemEvent = value;
      const { warningDialog } = this.$refs;
      if (!warningDialog) return;

      warningDialog.openDialog();
    },
    dialogOK() {
      this.$emit('input', this.itemEvent);
      this.itemEvent = {};
    },
    clearCard() {
      this.modelValue = null;
      this.onSelectChoice(null);
    },
    maskName(name) {
      const nameList = name.split(' ');
      const endIndex = nameList.length - 1;
      return nameList
        .map((v, i) => {
          // eslint-disable-next-line eqeqeq
          if (i == 0) {
            return v;
          }
          if (i === endIndex) {
            // eslint-disable-next-line no-return-assign
            return (i = '...');
          }
          return `${String(v).charAt(0)}.`;
        })
        .join(' ');
    },
    addCard() {
      this.modalFormCard = true
    },
    async saveCardMethod(creditCardForm) {
      this.createPatientCreditCard(creditCardForm);
    },
    async createPatientCreditCard(dataForm) {
      try {
        await createCreditCard(dataForm);
        this.$showSnackbar('Cartão cadastrado com sucesso!');
        this.modalFormCard = false
        this.isVisibilt = true
        this.addNewCard = true
      } catch (error) {
        this.$showSnackbar(error.response.data[0]);
      }
    },
    addSepa() {
      this.modalFormSepa = true
    },
    async saveSepadMethod(methodoSepaForm) {
       this.creatNewSepa(methodoSepaForm);
    },
    async creatNewSepa(dataForm) {
      try {
        await creatMethodSepa(dataForm);
        this.$showSnackbar('Débito Direto (SEPA) cadastrado com sucesso!');
        this.modalFormSepa = false
        this.isVisibilt = true
        this.addNewSepa = true
      } catch (error) {
        this.$showSnackbar(error.response.data[0]);
      }
    },
  },
};
</script>
<style scoped>
.accordeon-container {
  width: 100%;
  max-width: 526px;
  background-color: #fffde3;
}

@media screen and (max-width: 420px) {
  #noCard {
    flex-direction: column !important;
  }
}
</style>
